// CRA injects REACT_APP_* at build time from .env* files (do not call dotenv here).
const urlBase = process.env.REACT_APP_API_URL;
const urlPdf = process.env.REACT_APP_PDF_HOST;

export const getBrandIdUrl = urlBase;
export const urlHotels = `${urlBase}member/members/getCatalogPointRulesAndHotels`;
export const urlCatalogue = `${urlBase}member/members/getCatalogsForSpendPoints`;
export const loy3AppLoginUrl = `${urlBase}member/app_login`;
export const loy3AppLoginAsUser = `${urlBase}member/loginAsUser`;
export const loy3LoginUrl = `${urlBase}member/login`;
export const loy3LoadProfileDataUrl = `${urlBase}member/members/getLoyaltyMemberData`;

export const getBrandDetailsUrl = `${urlBase}member/getBrandDetails/`;
export const physicalCardStatusUrl = `${urlBase}member/secure/claimPhysicalCard/status`;
export const physicalCardUrl = `${urlBase}member/secure/claimPhysicalCard`;
export const checkUpcomingBookingUrl = `${urlBase}member/secure/checkForUpcomingBooking`;
export const getMemberBookingInfoUrl = `${urlBase}member/secure/getMemberBookingInfo`;
export const getBookingsByEntitlerAndIdPmsUrl = `${urlBase}member/secure/getLoyaltyBookingsByPmsIdAndPmsEntitler`;
export const redeemCoinsWithCodeUrl = `${urlBase}member/members/applyScratchCode`;
export const getBookingDetailsByHotelIdUrl = `${urlBase}member/secure/getBookingDetailsByHotelId`;
export const addToCartUrl = `${urlBase}member/secure/confirmCart`;
export const claimMyBookingUrl = `${urlBase}member/secure/claimMyBooking`;
export const uploadBookingPdfUrl = `${urlBase}member/secure/uploadBookingPdf`;
export const uploadFileUrl = `${urlBase}member/members/file/uploadFile`;

export const getSandos4U = `${urlBase}member/secure/getMemberShipInfo`;
export const getAllMembershipInfoUrl = `${urlBase}member/secure/getAllMembershipInfo`;
export const getPointsTransactionsUrl = `${urlBase}member/secure/pointTransactions`;
export const getShoppingCartItemsUrl = `${urlBase}member/secure/getShoppingCartItems`;
export const getTransactionDownloadVoucherUrl = `${urlBase}member/secure/getVoucherPdf`;
export const getTransactionVoucherPdfUrl = (transactionId) => `${urlPdf}assets/pdfs/${transactionId}`;
export const getHeroBannerUrl = `${urlBase}member/members/getHeroBannerForUser/`;

export const registrationInfo = `${urlBase}member/members/getLookupDataForRegistration/`
export const checkRegistrationEmailUrl = `${urlBase}member/members/checkRegistrationEmail`
export const resendEmailUrl = `${urlBase}member/members/resendActivationLink/`
export const resendActivationLinkByEmailUrl = `${urlBase}member/members/resendActivationLinkByEmail`
export const checkFacebookUrl = `${urlBase}member/secure/checkFacebookOrInstagramId/facebook`
export const connectAccountUrl = `${urlBase}member/secure/connectWithFacebookOrInstagram/`
export const checkInstagramUrl = `${urlBase}member/secure/checkFacebookOrInstagramId/instagram`

export const saveOrUpdateLoyaltyMember = `${urlBase}member/members/saveOrUpdatedLoyaltyMember`
export const unsubscribeMembershipUrl = `${urlBase}member/secure/unsubscribeMembership`
export const deleteMembershipUrl = `${urlBase}member/secure/deleteMembership`
export const changePwdUrl = `${urlBase}member/changePwd`;
export const getFriendsUrl = `${urlBase}member/members/getFriends`;
export const addPointsToFriendsUrl = `${urlBase}member/members/transferCoins/`;
export const inviteFriendUrl = `${urlBase}member/members/inviteFriend`
export const acceptFriendUrl = `${urlBase}member/members/acceptFriendShip`

export const deleteItemCartUrl = `${urlBase}member/secure/removeShoppingCartItem/`
export const redeemCartUrl = `${urlBase}member/secure/redeemPointsForShoppingCart`
export const feedbackCartUrl = `${urlBase}member/secure/transactionFeedback`
export const verifyRegistrationUrl = `${urlBase}member/members/verifyRegistrationToken?key=`
export const createPasswordUrl = `${urlBase}member/members/createPassword`
export const resetPasswordUrl = `${urlBase}member/updatePassword/`
export const resetPasswordRequestUrl = `${urlBase}member/resetPassword`
export const subscribeToNewsletterUrlAsAnonymous = `${urlBase}member/members/anonymousNewsletterSubscription`
export const subscribeToNewsletterUrl = `${urlBase}member/members/memberNewsletterSubscription`
